export const OmbudsmanData = {
  companyOptions: [
    {
      label: "Selecione a empresa",
      value: "",
    },
    {
      label: "Youse",
      value: "YOUSE",
    },
    {
      label: "Caixa Seguradora",
      value: "Caixa Seguradora",
    },
  ],
  cnpProducts: [
    {
      label: "Selecione o produto",
      value: "",
    },
    {
      label: "Habitacional",
      value: "HAB",
    },
    {
      label: "Residencial",
      value: "RD",
    },
    {
      label: "Saúde",
      value: "SAÚDE",
    },
    {
      label: "Empresarial",
      value: "RD EMPRESARIAL",
    },
  ],
  contactWays: [
    {
      label: "E-mail",
      value: "Email",
    },
    {
      label: "WhatsApp",
      value: "WhatsApp",
    },
    {
      label: "Ligação",
      value: "Ligacao",
    },
  ],
};
